import React from 'react';
import { Link } from 'react-router-dom';

const Testimonial: React.FC = () => {
  return (
    <div className="container-fluid testimonial bg-dark py-5">
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-lg-6 col-xl-5 wow fadeInUp" data-wow-delay="0.2s">
            <h4 className="text-primary">Testimonial</h4>
            <h1 className="display-4 text-white mb-4">Powerful Praise From Our Valued Customers</h1>
            <p className="mb-4 text-white">Hear from industry leaders who trust WTIL for their water treatment needs. 
              Our partnerships with leading companies across various sectors speak to our commitment 
              to excellence and reliability.
            </p>
            <Link className="btn btn-light py-3 px-5" to="#">View All Reviews</Link>
          </div>
          <div className="col-lg-6 col-xl-7 wow fadeInUp" data-wow-delay="0.4s">
            <div className="owl-carousel testimonial-carousel">
              <div className="testimonial-item">
                <div className="testimonial-quote"><i className="fa fa-quote-right fa-2x"></i>
                </div>
                <div className="testimonial-inner p-2">
                  <div className="d-flex align-items-center justify-content-center bg-light rounded-circle" style={{width: '80px', height: '80px'}}>
                    <i className="fas fa-user fa-2x text-primary"></i>
                  </div>
                  <div className="ms-4">
                    <h5>Mr. Sanjeev Trehan</h5>
                    <p>Ultratech Cement</p>
                    <div className="d-flex text-primary">
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                    </div>
                  </div>
                </div>
                <div className="customer-text p-4">
                  <p className="mb-0">"WTIL's chemical dosing and SANYOL® AVT programs have significantly enhanced the performance of our boiler and cooling systems. Their technical team is extremely proactive and has helped us maintain system health while optimizing chemical costs. A reliable partner in true sense."</p>
                </div>
              </div>
              <div className="testimonial-item">
                <div className="testimonial-quote"><i className="fa fa-quote-right fa-2x"></i>
                </div>
                <div className="testimonial-inner p-2">
                  <div className="d-flex align-items-center justify-content-center bg-light rounded-circle" style={{width: '80px', height: '80px'}}>
                    <i className="fas fa-user fa-2x text-primary"></i>
                  </div>
                  <div className="ms-4">
                    <h5>Mr. Bhanu Pratap</h5>
                    <p>Sangam Spinners</p>
                    <div className="d-flex text-primary">
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                    </div>
                  </div>
                </div>
                <div className="customer-text p-4">
                  <p className="mb-0">"The upgradation and O&M support provided by Wasser Technochem for our ETP has led to better compliance and lower sludge generation. Their approach is professional and their solutions are well-customized to our operational conditions."</p>
                </div>
              </div>
              <div className="testimonial-item">
                <div className="testimonial-quote"><i className="fa fa-quote-right fa-2x"></i>
                </div>
                <div className="testimonial-inner p-2">
                  <div className="d-flex align-items-center justify-content-center bg-light rounded-circle" style={{width: '80px', height: '80px'}}>
                    <i className="fas fa-user fa-2x text-primary"></i>
                  </div>
                  <div className="ms-4">
                    <h5>Mr. Alex Devasia</h5>
                    <p>Shree Cement</p>
                    <div className="d-flex text-primary">
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                    </div>
                  </div>
                </div>
                <div className="customer-text p-4">
                  <p className="mb-0">"The UF-RO-MB system installed by WTIL for DM water generation has proven both technically sound and cost-efficient. Their capex projects are led by highly skilled and experienced teams that has ensured fast project execution saving immense costs. We value their partnership."</p>
                </div>
              </div>
              <div className="testimonial-item">
                <div className="testimonial-quote"><i className="fa fa-quote-right fa-2x"></i>
                </div>
                <div className="testimonial-inner p-2">
                  <div className="d-flex align-items-center justify-content-center bg-light rounded-circle" style={{width: '80px', height: '80px'}}>
                    <i className="fas fa-user fa-2x text-primary"></i>
                  </div>
                  <div className="ms-4">
                    <h5>Mr. Ravi Ahlawat</h5>
                    <p>Subros Ltd.</p>
                    <div className="d-flex text-primary">
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                    </div>
                  </div>
                </div>
                <div className="customer-text p-4">
                  <p className="mb-0">"WTIL's O&M services along with Speciality chemicals program has brought us measurable improvements in cycles of concentration and reduced scaling issues. Their service team ensured consistency and the overall program added value to our utilities management."</p>
                </div>
              </div>
              <div className="testimonial-item">
                <div className="testimonial-quote"><i className="fa fa-quote-right fa-2x"></i>
                </div>
                <div className="testimonial-inner p-2">
                  <div className="d-flex align-items-center justify-content-center bg-light rounded-circle" style={{width: '80px', height: '80px'}}>
                    <i className="fas fa-user fa-2x text-primary"></i>
                  </div>
                  <div className="ms-4">
                    <h5>Mr. Subodh Manchanda</h5>
                    <p>Hero Motocorp</p>
                    <div className="d-flex text-primary">
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                    </div>
                  </div>
                </div>
                <div className="customer-text p-4">
                  <p className="mb-0">"Their annual maintenance contract along with speciality chemicals has ensured hassle-free operation of our water treatment facilities. The team is responsive, well-trained, and committed to long-term results. WTIL has become an integral part of our utility ecosystem."</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
